export default "__VITE_ASSET__BQ_UfDuF__"